import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    container: {
        position: 'relative',
        marginBottom: 32
    },
    titleBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
        width: '100%',
        height: 42,
        padding: theme.spacing(0, 3, 0, 5),
        fontSize: 14,
        borderColor: '#02BBD3',
        borderWidth: 1,
        borderStyle: 'solid',
        boxSizing: 'border-box',
        borderRadius: 4,
        backgroundColor: '#F9F9F9',
        cursor: 'pointer'
    },
    titleBoxOpen: {
        borderColor: '#C7CEE2'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: theme.spacing(5),
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        height: 24
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    expandIcon: {
        color: '#007EA7'
    },
    leftView: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    dropDownBox: {
        position: 'absolute',
        height: 50,
        zIndex: 99999,
        width: '100%',
        cursor: 'pointer'
    },
    dropDownBoxHidden: {
        display: 'none'
    },
    rowContainer: {
        marginTop: theme.spacing(1),
        borderWidth: 1,
        borderRadius: 4,
        borderColor: '#C7CEE2',
        borderStyle: 'solid',
        backgroundColor: 'white',
        zIndex: 999,
        cursor: 'pointer'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing(0, 1, 0, 5),
        width: '100%',
        height: 40,
        borderColor: '#C7CEE2',
        borderWidth: 0,
        borderBottomWidth: 1,
        borderStyle: 'solid',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#02BBD3',
            color: 'white'
        },
    },
    lastRow: {
        borderBottomWidth: 0,
    },
    rowClick: {
        backgroundColor: '#02BBD3',
        color: 'white'
    },
    item: {
        marginLeft: theme.spacing(3),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer'
    },
    closeIcon: {
        marginRight: theme.spacing(1),
        color: '#007EA7',
        fontSize: 20,
        fontWeight: 'bold'
    }
}))

const CustomDropDown = ({ title, data, expand, onClickDropDown, format }) => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    const [dropDownData, setDropDownData] = React.useState(data);
    const [parentTitle, setParentTitle] = React.useState(null);
    const [childTitle, setChildTitle] = React.useState(null);

    React.useEffect(() => {
        setExpanded(expand)
    }, [expand])

    React.useEffect(() => {
        if(format) {
            setParentTitle(null)
            setChildTitle(null)
            setDropDownData(data)
            setExpanded(false)
        }
    }, [format])

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    return (
        <div className={classes.container}>
            <div
                className={clsx(classes.titleBox, {
                    [classes.titleBoxOpen]: !expanded
                })}
                onClick={() => {
                    handleExpandClick()
                    if (onClickDropDown) {
                        onClickDropDown([parentTitle, childTitle])
                    }
                }}
            >
                {title}
                <div className={classes.leftView}>
                    <Item subTitle={parentTitle} onTab={ async () => {
                        await setParentTitle(null);
                        await setChildTitle(null);
                        setDropDownData(data);
                        setExpanded(true);
                        if (onClickDropDown) {
                            onClickDropDown([null, null])
                        }
                    }} />
                    <Item subTitle={childTitle} onTab={() => {
                        setChildTitle(null);
                        setExpanded(true);
                        if (onClickDropDown) {
                            onClickDropDown([parentTitle, null])
                        }
                    }} />
                    <div
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded
                        })}
                    >
                        <ExpandMoreIcon className={classes.expandIcon} />
                    </div>
                </div>
            </div>
            <div
                className={clsx(classes.dropDownBox, {
                    [classes.dropDownBoxHidden]: !expanded
                })}>
                <div className={classes.rowContainer}>
                    {
                        dropDownData.map((item, index) => {
                            return <Row
                                key={index}
                                subTitle={item.title}
                                onTab={() => {
                                    if (dropDownData == data) {
                                        setParentTitle(item.title)
                                        onClickDropDown([item.title, null])
                                    } else {
                                        setChildTitle(item.title)
                                        onClickDropDown([parentTitle, item.title])
                                    }

                                    if (item.hasOwnProperty('child')) {
                                        setDropDownData(item.child)
                                    } else {
                                        setExpanded(false)
                                    }
                                }}
                                checkLastRow={index == (dropDownData.length - 1)}
                            />
                        })
                    }
                </div>
            </div>
        </div>
    )
}

const Row = ({ subTitle, onTab, checkLastRow }) => {
    const classes = useStyles();
    return (
        <div
            className={clsx(classes.row, {
                [classes.lastRow]: checkLastRow
            })}
            onClick={() => {
                if (onTab) {
                    onTab();
                }
            }}
        >
            {subTitle}
        </div>
    )
}

const Item = ({ subTitle, onTab }) => {
    const classes = useStyles()
    return (
        subTitle && <div className={classes.item} >
            <CloseIcon
                className={classes.closeIcon}
                onClick={() => {
                    if (onTab) {
                        onTab()
                    }
                }}
            />
            {subTitle}
        </div>
    )
}

export default CustomDropDown
